var _line, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDividerPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 42,
    viewBox: "0 0 268 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 22.5,
    x2: 268,
    y2: 22.5,
    stroke: "#4A4A4A",
    strokeDasharray: "6 6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1237_519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.504 35.1504C125.979 33.4694 127.468 27.7494 128.082 25.382C126.093 25.3188 123.982 25.0964 122.115 24.6701C120.551 25.9125 117.544 28.241 116.832 28.3292C115.609 28.4818 115.393 28.195 115.946 27.1817C116.5 26.1683 118.178 22.8102 118.178 22.8102C118.178 22.8102 116.604 19.4364 116.081 18.419C115.558 17.4017 115.783 17.116 117.001 17.2804C117.71 17.3765 120.646 19.7305 122.172 20.9877C124.052 20.5786 126.17 20.3763 128.161 20.3305C127.618 17.9575 126.304 12.2255 125.879 10.5404C125.506 9.06044 126.671 9.63685 126.671 9.63685C127.208 9.89173 128.277 10.542 128.665 11.0463C131.079 14.1795 134.721 19.1903 135.576 20.3697L137.71 20.3819C146.352 20.4215 147.155 22.3547 147.147 22.9442C147.138 23.5337 146.276 25.4585 137.633 25.4201L135.499 25.4122C134.609 26.5826 130.814 31.56 128.305 34.6712C127.901 35.1716 126.812 35.8127 126.268 36.0621C126.267 36.0612 125.085 36.6264 125.504 35.1504Z",
    fill: "#CA3657"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1237_519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(130.451) rotate(35.5689)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerPlane);
export default __webpack_public_path__ + "static/media/divider-plane.c86ee6ca684ec823846055d3835535b7.svg";
export { ForwardRef as ReactComponent };